import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Home, HelpCircle, BookOpen } from 'lucide-react';
import ExpertiseAreas from './ExpertiseAreas';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const handleExpertiseClick = (e) => {
    e.preventDefault();
    const element = document.querySelector('#expertise-areas');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else if (location.pathname !== '/') {
      window.location.href = '/#expertise-areas';
    }
  };

  const mainMenuItems = [
    { title: 'דף הבית', icon: <Home className="w-5 h-5" />, href: '/' },
    { 
      title: 'תחומי התמחות', 
      icon: <BookOpen className="w-5 h-5" />, 
      href: '/#expertise-areas',
      onClick: handleExpertiseClick
    },
    { title: 'חדלות פרעון והוצאה לפועל', href: '/topic/execution' },
    { title:'נזיקין ואזרחי', href: '/topic/damages' },
    { title: 'נדל"ן', href: '/topic/realestate' },
    { title: 'ייפוי כוח מתמשך', href: '/topic/powerOfAttorney' },
  ];

  const contactItem = { title: 'צור קשר', icon: <Phone className="w-5 h-5" />, href: '/contact' };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const linkClasses = (isActive) => `
    flex items-center px-3 py-2 rounded-md text-sm font-medium
    transition-colors duration-200
    ${isActive ? 'text-brand-600' : 'text-gray-700 hover:text-brand-600'}
  `;

  return (
    <nav 
      className={`
        fixed top-0 left-0 right-0 z-50 font-heebo
        transition-all duration-300
        ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}
      `}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-20">
          {/* Logo and Main Menu Items */}
          <div className="flex items-center flex-1">
            <Link to="/" className="flex items-center">
              <img src="/logoArelChen.jpg" alt="Logo" className="h-12 w-12" />
            </Link>
            
            {/* Desktop Main Menu */}
            <div className="hidden md:flex items-center mr-8 space-x-8 space-x-reverse">
              {mainMenuItems.map((item) => (
                item.onClick ? (
                  <a
                    key={item.title}
                    href={item.href}
                    onClick={item.onClick}
                    className={linkClasses(location.pathname === item.href)}
                  >
                    {item.icon && <span className="ml-2">{item.icon}</span>}
                    {item.title}
                  </a>
                ) : (
                  <Link
                    key={item.title}
                    to={item.href}
                    className={linkClasses(location.pathname === item.href)}
                  >
                    {item.icon && <span className="ml-2">{item.icon}</span>}
                    {item.title}
                  </Link>
                )
              ))}
            </div>
          </div>

          {/* Contact Link - Always on the left */}
          <div className="hidden md:flex items-center">
            <Link
              to={contactItem.href}
              className={linkClasses(location.pathname === contactItem.href)}
            >
              {contactItem.icon && <span className="ml-2">{contactItem.icon}</span>}
              {contactItem.title}
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-brand-600 transition-colors duration-200"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {[...mainMenuItems, contactItem].map((item) => (
                item.onClick ? (
                  <a
                    key={item.title}
                    href={item.href}
                    onClick={(e) => {
                      setIsOpen(false);
                      item.onClick(e);
                    }}
                    className={`
                      flex items-center px-3 py-2 rounded-md text-base font-medium
                      transition-colors duration-200
                      ${location.pathname === item.href 
                        ? 'text-brand-600 bg-brand-50' 
                        : 'text-gray-700 hover:text-brand-600 hover:bg-gray-50'}
                    `}
                  >
                    {item.icon && <span className="ml-2">{item.icon}</span>}
                    {item.title}
                  </a>
                ) : (
                  <Link
                    key={item.title}
                    to={item.href}
                    className={`
                      flex items-center px-3 py-2 rounded-md text-base font-medium
                      transition-colors duration-200
                      ${location.pathname === item.href 
                        ? 'text-brand-600 bg-brand-50' 
                        : 'text-gray-700 hover:text-brand-600 hover:bg-gray-50'}
                    `}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.icon && <span className="ml-2">{item.icon}</span>}
                    {item.title}
                  </Link>
                )
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;